import {getPrivateAxios} from '../../libs';
import {Collection} from './types';

export const fetchCollection = async (id: string) => {
  return getPrivateAxios()
    .get<Collection>(`/collections/${id}`)
    .then((response) => {
      return response.data;
    });
};
